<script>
import { mapGetters } from "vuex";

import VueSlider from "vue-slider-component";
import "vue-slider-component/theme/default.css";

export default {
  components: { VueSlider },
  data() {
    return {
      value: [
        this.$store.getters.getFiltroDuracionMin,
        this.$store.getters.getFiltroDuracionMax
      ]
    };
  },
  computed: {
    ...mapGetters([
      "isPreloader",
      "getFiltroDuracionMin",
      "getFiltroDuracionMax"
    ]),
    labelMin() {
      let min = this.$store.getters.getFiltroDuracionMin;
      return min + (min === 1 ? " Noche" : " Noches");
    },
    labelMax() {
      let max = this.$store.getters.getFiltroDuracionMax;
      return max + (max === 1 ? " Noche" : " Noches");
    }
  },
  watch: {
    value(payload) {
      this.$store.commit("setFiltroDuracion", payload);
    }
  },
  methods: {
    clear() {
      if (
        this.value[0] > this.getFiltroDuracionMin ||
        this.value[1] < this.getFiltroDuracionMax
      ) {
        this.value = [this.getFiltroDuracionMin, this.getFiltroDuracionMax];
      }
    }
  }
};
</script>

<template>
  <div class="panel-body">
    <div class="rangos">
      <span v-text="labelMin"></span>
      <small>-</small>
      <span v-text="labelMax"></span>
    </div>
    <vue-slider v-model="value" :min="getFiltroDuracionMin" :max="getFiltroDuracionMax"></vue-slider>
  </div>
</template>

<style lang="scss" scoped>
.rangos {
  text-align: center;
  font-weight: 500;
  margin-bottom: 10px;
  font-size: 14px;
  color: #ccd1d9;
  > small {
    font-size: 12px;
    color: #aab2bd;
  }
  > span {
    color: #656d78;
  }
}
</style>